@import (reference) "../../references.less";

@ratio: 1.4;
.root {
  .disableSelection();
}

.wrapper {
  position: relative;

  &:hover {
    .container_rollover {
      clip-path: polygon(100% 0, 100% 0, 100% 100%, 100% 100%);
    }
  }
}

.container {
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;

  .R(border-radius, 60);
  background-color: @color-white;

  .R(height, 35 * @ratio, 40 * @ratio);
  .R(padding-left, 16 * @ratio, 23 * @ratio);
  .R(padding-right, 16 * @ratio, 23 * @ratio);
  .R(padding-top, 16 * @ratio, 23 * @ratio);
  .R(padding-bottom, 16 * @ratio, 23 * @ratio);
}

.container_rollover.container {
  z-index: 1;
  position: absolute;
  left: 0;
  transition: clip-path 0.5s ease;
  clip-path: polygon(-10% 0, 100% 0, 100% 100%, -40% 100%);
  background-color: @color-red;

  .label {
    color: @color-white;
  }
}

.label {
  .R(font-size, 13 * @ratio, 15 * @ratio);
  color: @color-red;
}
